@if (data) {
<div class="preview-welcome-screen" [class.mobile-view]="viewMode === 'mobile'"
  [style.background-color]="viewMode === 'mobile' ? '#e5e5e5' : data.backgroundColor"
  [style.display]="'flex'" [style.flex-direction]="viewMode === 'mobile' ? 'row' : 'column'"
  [style.justify-content]="viewMode === 'mobile' ? '' : data.verticalAlignment"
  [style.align-items]="viewMode === 'mobile' ? '' : data.horizontalAlignment">
  <div class="preview-welcome-screen-content" [class.mobile-view]="viewMode === 'mobile'"
    [style.display]="'flex'" [style.flex-direction]="'column'"
    [style.align-items]="viewMode === 'mobile' ? 'center' : data.horizontalAlignment"
    [style.text-align]="viewMode === 'mobile' ? 'center' : data.textAlign"
    [style.background-color]="viewMode === 'mobile' ? data.backgroundColor : 'transparent'"
  >
    @if (data.logoUrl) {
    <img 
    [class.mobile-view]="viewMode === 'mobile'"
    [src]="data.logoUrl" alt="Logo" [style.width]="data.logoSizePx + 'px'" [style.height]="'auto'"
      [style.object-fit]="'contain'" />
    }
    <h3 
    [class.mobile-view]="viewMode === 'mobile'"
    class="m-0 p-0" [style.color]="data.titleColor" [style.font-size]="data.titleFontSize"
      [style.font-family]="data.titleFontFamily" [style.font-weight]="data.titleFontWeight">
      {{ data.title }}
    </h3>
    <p 
    [class.mobile-view]="viewMode === 'mobile'"
    class="m-0 p-0" [style.color]="data.descriptionColor" [style.font-size]="data.descriptionFontSize"
      [style.font-family]="data.descriptionFontFamily" [style.font-weight]="data.descriptionFontWeight">
      {{ data.description }}
    </p>
    <button 
    [class.mobile-view]="viewMode === 'mobile'"
    type="button" class="preview-welcome-screen-content-start" [style.background-color]="data.buttonBgColor"
      [style.color]="data.buttonColor" [style.font-size]="data.buttonFontSize + 'px'"
      [style.font-family]="data.buttonFontFamily" [style.font-weight]="data.buttonFontWeight"
      [style.cursor]="'pointer'" (click)="onStartClick()">
      {{ data.buttonName }}
    </button>
  </div>
</div>
}
